import * as React from 'react';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../_pageWrappers/MemberPageWrapper';
import { AgendaMeetingListingView } from '../_components/activities/AgendaMeetingListingView';




export default function WorkgroupMeetingListingPage(): JSX.Element 
{
	return (
		<MemberPageWrapper selectedMenuItemKey="workgroupmeeting" breadCrumbs={[{ text: 'AMO møder', url: '' }]}>
            <WorkgroupMeetingListingPageContent />
		</MemberPageWrapper>
	);
}

function WorkgroupMeetingListingPageContent(): JSX.Element
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewActivity']);

    React.useEffect(() =>
    {
        document.title = 'Amorgy - AMO møder';
    }, []);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <AgendaMeetingListingView
            generalActivityHeaderText='AMO møder'
            generalActivityHeaderIcon='calendar_month'
            currentActivitiesHeaderIcon='calendar_month'
            createNewButtonText='Opret nyt AMO møde'
            currentActivitiesHeaderText='Aktuelle AMO møder'
            pastActivitiesHeaderText='TIDLIGERE AMO MØDER'
            pastActivitiesHeaderIcon='calendar_check'
            type='WorkgroupMeeting' />
    );
}
